import React from 'react';
import './TextInput.css';
import { MDBInput, MDBValidation, MDBValidationItem } from 'mdb-react-ui-kit';

type Props = {
  value: string;
  name: string;
  label: string;
  errorMessage?: string;
  className?: string;
  onChange: (e: any) => void;
};

const TextInput: React.FC<Props> = ({
  value,
  name,
  label,
  errorMessage,
  className,
  onChange,
}) => {
  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      setTimeout(() => {
        removeWasValidated();
      }, 10);
    }
  };

  const removeWasValidated = () => {
    var element = document.querySelector('.was-validated');
    if (element) {
      element.classList.remove('was-validated');
    }
  };

  return (
    <div className={`TextInput ${className}`}>
      <MDBValidation>
        <MDBValidationItem className='input' feedback={errorMessage} invalid>
          <MDBInput
            value={value}
            name={name}
            onChange={onChange}
            required
            label={label}
            className={
              errorMessage !== '' && errorMessage !== undefined
                ? 'is-invalid'
                : ''
            }
            onKeyDown={handleKeyDown}
          />
        </MDBValidationItem>
      </MDBValidation>
    </div>
  );
};

export default TextInput;
